import React, { useEffect, useState } from "react";
import { ReactSVG } from "react-svg";

// region Imports - Assets
import Login from "@assets/Backgrounds/Login.svg";
// endregion Imports - Assets
// region Imports - Apollo Client
import { useQuery } from "@apollo/client";
import {
  paramGetLoginColor,
  TParamGetLoginColorQueries
} from "@graphql/groups/param/query.graphql";
// endregion Imports - Apollo Client
// region Imports - Styles
import { SVGWrapper } from "./styles";
// endregion Imports - Styles

const LoginBackground: React.FC = () => {

  // region States
  const [color, setColor] = useState<string>(localStorage.getItem("@Topcon:loginColor") ?? "#56C2FF");
  // endregion States
  // region Graphql Queries
  const { data } = useQuery<
    TParamGetLoginColorQueries
  >(paramGetLoginColor(["key"]), {
    fetchPolicy: "network-only"
  });

  // endregion Graphql Queries
  // region Effects
  useEffect(() => {
    if (data?.param?.getLoginColor?.status !== "SUCCESS") return;

    const newColor = data.param.getLoginColor!.result!.key;

    setColor(newColor);

    localStorage.setItem("@Topcon:loginColor", newColor);
  }, [data]);
  // endregion Effects

  return (
    <SVGWrapper color={color}>
      <ReactSVG src={Login} />
    </SVGWrapper>
  );
};

export default LoginBackground;